import { useState } from 'react';
import useCustomFields from '../../custom_categories/hooks/useCustomFields';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import Checkbox from '../../../../components/Checkbox';
import { useLocalStorage } from '@uidotdev/usehooks';
import { MdVisibility, MdClose } from 'react-icons/md';
import { Button } from '@/components/Button';

interface Props {
  customFields: { id: number; name: string }[];
}

export default function VisibleDialog({ customFields }: Props) {
  const { data, isSuccess } = useCustomFields();
  const [isOpen, setIsOpen] = useState(false);
  // NOTE: created_at用に100で仮id定義
  const [visibleCustomFieldIds, setVisibleCustomFieldIds] = useLocalStorage<(string | number)[]>(
    'visibleCustomFieldIds',
    [...customFields.map((cf) => cf.id), 100]
  );
  const [tempVisibleCustomFieldIds, setTempVisibleCustomFieldIds] =
    useState<(string | number)[]>(visibleCustomFieldIds);

  return (
    <>
      <Button
        color="secondary"
        size="md"
        onClick={() => {
          setTempVisibleCustomFieldIds(visibleCustomFieldIds);
          setIsOpen(true);
        }}
      >
        <MdVisibility className="size-icon-xs" />
        項目
      </Button>
      <Dialog
        open={isOpen}
        onOpenChange={(nextOpen) => {
          if (!nextOpen) setIsOpen(false);
        }}
      >
        <DialogContent className="flex max-h-[85vh] w-[90vw] max-w-[860px] flex-col rounded-md">
          <DialogTitle className="flex items-center justify-between border-b border-solid border-border px-lg py-md text-lg! font-bold!">
            表示項目の設定
            <Button
              color="tertiary"
              size="md"
              onClick={() => {
                setTempVisibleCustomFieldIds([]);
              }}
            >
              <MdClose className="size-icon-xs" />
              すべての選択を解除
            </Button>
          </DialogTitle>
          <div className="flex-auto overflow-y-auto p-lg">
            <div className="grid grid-cols-5 gap-sm">
              {isSuccess && (
                <>
                  {data.customFields.map((cf) => (
                    <Checkbox
                      key={cf.id}
                      value={cf.id}
                      checked={tempVisibleCustomFieldIds.includes(cf.id)}
                      onChange={(v) => {
                        let valueCopy = [...tempVisibleCustomFieldIds];
                        valueCopy = v
                          ? [...valueCopy, cf.id]
                          : valueCopy.filter((v) => v !== cf.id);
                        setTempVisibleCustomFieldIds(valueCopy.sort());
                      }}
                    >
                      <span className="text-sm font-normal">{cf.name}</span>
                    </Checkbox>
                  ))}
                  <Checkbox
                    value={100}
                    checked={tempVisibleCustomFieldIds.includes(100)}
                    onChange={(v) => {
                      let valueCopy = [...tempVisibleCustomFieldIds];
                      valueCopy = v ? [...valueCopy, 100] : valueCopy.filter((v) => v !== 100);
                      setTempVisibleCustomFieldIds(valueCopy.sort());
                    }}
                  >
                    <span className="text-sm font-normal">登録日</span>
                  </Checkbox>
                </>
              )}
            </div>
          </div>
          <div className="flex justify-end gap-4 border-t border-solid border-border px-lg py-md">
            <Button
              color="secondary"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              キャンセル
            </Button>
            <Button
              onClick={() => {
                setVisibleCustomFieldIds(tempVisibleCustomFieldIds);
                setIsOpen(false);
              }}
            >
              適用
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
